import { render } from "./Datatable.vue?vue&type=template&id=3877ef8e"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=3877ef8e&lang=css"
script.render = render

export default script